import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const StyledText = styled.div`
  font-family: Nimbus Sans Light;
  font-size: 20px;
  line-height: 26px;
  color: ${tokens.ColorGrey900};
  padding-top: 32px;
  margin-bottom: 24px;
`;

class RetirementAgeModal extends Component<any, any> {
  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Why we’re suggesting modeling this retirement age'} showClose={true} />
        <ReactModalContent>
          <StyledText id={`retirement-age-modal-text`}>
            We may have suggested modeling a retirement age and contribution increase to help improve your outlook.
            These suggestions work together to help improve your chances of achieving your income goal throughout
            retirement. Explore different ages to model the impact on your estimates and projections.
          </StyledText>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default RetirementAgeModal;
